import { Navigate } from 'react-router-dom';
import FuseLoading from '@fuse/core/FuseLoading';
import {
  useGetAccountSettingsQuery,
  useGetUserPermissionsQuery
} from '@/app/(control-panel)/admin/settings/SettingsApi';
import { getOpeningPagePath } from '@/configs/openingPageConfig';

/**
 * Resolves the "/" (home) route to the page the user picked as their opening page in
 * Account settings - the dashboard by default, or when the chosen page sits behind a
 * permission category the user no longer holds.
 *
 * Reads the same account-settings query the Account tab writes (the update invalidates it),
 * so a new choice applies on the next visit to "/" without a reload. The permissions query
 * is the one NavigationLoader already holds, so no extra request is made for it.
 */
function OpeningPageRedirect() {
  const { data: account, isLoading: accountLoading } = useGetAccountSettingsQuery();
  const { data: permissions, isLoading: permissionsLoading } = useGetUserPermissionsQuery();

  if (accountLoading || permissionsLoading) {
    return <FuseLoading />;
  }

  return (
    <Navigate
      to={getOpeningPagePath(account?.openingPage, permissions)}
      replace
    />
  );
}

export default OpeningPageRedirect;
